import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const Dashboard = React.lazy(() => import("./Dashboard"));

function DashboardPage(props) {
  const { t } = useTranslate();
  usePageInit(t({ key: "dashboard.pageTitle", defaultValue: "Smart Portal" }));
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({
            key: "dashboard.loading",
            defaultValue: "Loading CTM Dashboard",
          })}
        />
      }
    >
      <Dashboard {...props} />
    </Suspense>
  );
}

export default DashboardPage;
